import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { PageComponent } from '@shared/components';
import { ContentPageId } from '@shared/models';
import { DAOfferContent } from '@shared/services/content/content-jsons/open-choice/da-offer.content';
import { OpenChoiceCommonContent } from '@shared/services/content/content-jsons/open-choice/open-choice-common.content';
import * as fromRootStore from '@store/index';

@Component({
  selector: 'app-da-offer',
  templateUrl: './da-offer.component.html',
  styleUrl: './da-offer.component.scss',
})
export class DAOfferComponent extends PageComponent implements OnInit, OnDestroy {
  content = DAOfferContent;
  openChoiceCommonContent = OpenChoiceCommonContent;

  constructor(globalStore: Store<fromRootStore.State>) {
    super(ContentPageId.daoffer, globalStore);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.globalStore.dispatch(fromRootStore.gotDAOffer());
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  trackAdobeProcessSideStep(acceptedDAOffer: boolean): void {
    const data = {
      processType: `coo-minor-flow`,
      processSideStep: `coo-minor-gc-offer-${acceptedDAOffer ? 'yes' : 'no'}`,
    };

    this.globalStore.dispatch(fromRootStore.TrackProcessSideStep(data));
  }

  onContinueAsDA(): void {
    this.globalStore.dispatch(fromRootStore.acceptDAOffer());
    this.trackAdobeProcessSideStep(true);
    this.globalStore.dispatch(fromRootStore.Next());
  }

  onContinueWithoutDA(): void {
    this.globalStore.dispatch(fromRootStore.rejectDAOffer());
    this.trackAdobeProcessSideStep(false);
    this.globalStore.dispatch(fromRootStore.Go({ path: [`secure/minor-transfer/review`] }));
  }
}
